import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppStatus, NavNodeKeys, SliceNames } from '../../services/enums';
// import {LatLng} from 'react-native-maps';

export interface IHazelAction {
  sender?: string;
  description?: string;
}

export interface IApp {
  nnHash: string | null;
  showWebNavigationBar: boolean;
  status: AppStatus;
  title: string | null;
  // userApprovedLocalNetworkUsage: boolean;
  // currentUserLocation: LatLng;
}

export interface IAppUpdateKeyValue {
  key: string;
  value: any;
}

const initialState: IApp = {
  nnHash: null,
  showWebNavigationBar: true,
  status: AppStatus.Start,
  title: null,
  // userApprovedLocalNetworkUsage: false,
  // currentUserLocation: {latitude: 0.0, longitude: 0.0},
};

const appSlice = createSlice({
  initialState,
  name: SliceNames.app,
  reducers: {
    activate(_state, _action: PayloadAction<void>) {
      // See saga for behavior
    },
    updateStore(state, action: PayloadAction<IAppUpdateKeyValue>) {
      const { key } = action.payload;
      // @ts-ignore
      state[key] = action.payload.value;
    },
    updateStoreSlice(state, action: PayloadAction<any>) {
      state = action.payload;
    },
  },
});

export const appReducer = appSlice.reducer;

export const {
  activate: app_activate,
  updateStore: app_updateStore,
  updateStoreSlice: app_updateStoreSlice,
} = appSlice.actions;
